export const LocalStorageKeys = Object.freeze({
	HiddenHeaders: 'mfDisabledHeaders',
});
